module.exports = __webpack_public_path__ + "img/39.a5866345.jpg";